import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";
import { initIfConsented, trackPageView } from "@/lib/analytics";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Blog } from "./pages/Blog";
import { BlogPost } from "./pages/BlogPost";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";

initIfConsented();

function ScrollToTop() {
    const { pathname, search } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); trackPageView(pathname); }, [pathname]);

    // Handle subscription/unsubscribe redirects from email links
    useEffect(() => {
        const params = new URLSearchParams(search);
        if (params.get("subscribed") === "true") {
            toast.success("You're subscribed! Thanks for signing up.");
            window.history.replaceState({}, "", pathname);
        } else if (params.get("unsubscribed") === "true") {
            toast.success("You've been unsubscribed successfully.");
            window.history.replaceState({}, "", pathname);
        }
    }, [search, pathname]);

    return null;
}

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
